import ScreensaverContentsContainer from 'components/feature/screensaver/contents/list/ScreensaverContentsContainer';
import React from 'react';

const ScreensaverContentsPage = () => {
  return <ScreensaverContentsContainer />;
};
export default ScreensaverContentsPage;
